// extracted by mini-css-extract-plugin
export default {"advertDetailService__label":"c-q_fK","advertDetailService__price":"c-q_fL"};